// extracted by mini-css-extract-plugin
export default {"modal":"SuccessPopup_modal__YzLxF","title":"SuccessPopup_title__1qa1z","button":"SuccessPopup_button__MUxou"};